"use strict";

import { Environment, Network, RecordSource, Store } from 'relay-runtime';
import { relayLogFn } from './environment';
import { fetchQuery } from './fetch';
const STORE_ENTRIES = 1500;
const STORE_CACHE_RELEASE_TIME = 10 * 60 * 1000; // 10 mins

let withSubscription = false;
const agRelayClientWithSub = '__AG_RelayClientWithSub__';
const agRelayClient = '__AG_RelayClient__';
let persistEnv = null;
export const getMemoEnv = withSub => {
  if (!process.__browser__ || typeof window === 'undefined') return persistEnv;
  return withSub ? window[agRelayClientWithSub] : window[agRelayClient];
};
export const setIsWithSub = withSub => {
  withSubscription = withSub;
};
export const getIsWithSub = () => withSubscription;
export const setMemoEnv = (withSub, env) => {
  if (!process.__browser__ || typeof window === 'undefined') persistEnv = env;else {
    if (withSub) window[agRelayClientWithSub] = env;else window[agRelayClient] = env;
  }
};

/**
 * Creates a new [Relay Environment]{@link Environment}. This environment creation will memo in CSR contexts, to then
 * subsequently use {@link getEnvironment} to retrieve.
 *
 * @supported CSR, SSR
 */
export const createEnvironment = options => {
  var _options$records, _options$fetcherOptio;
  withSubscription = false;
  if (getMemoEnv(withSubscription)) return getMemoEnv(withSubscription);
  const source = new RecordSource((_options$records = options === null || options === void 0 ? void 0 : options.records) !== null && _options$records !== void 0 ? _options$records : {});
  const store = new Store(source, {
    gcReleaseBufferSize: STORE_ENTRIES,
    queryCacheExpirationTime: STORE_CACHE_RELEASE_TIME
  });
  const network = Network.create(fetchQuery((_options$fetcherOptio = options === null || options === void 0 ? void 0 : options.fetcherOptions) !== null && _options$fetcherOptio !== void 0 ? _options$fetcherOptio : {}));
  const environment = new Environment({
    isServer: !process.__browser__,
    log: relayLogFn,
    treatMissingFieldsAsNull: true,
    configName: 'standard',
    network,
    store
  });
  setMemoEnv(withSubscription, environment);
  return environment;
};
export const initPersistedEnvironment = (initialRecords, withSub = false) => {
  var _getMemoEnv;
  // Create a network layer from the fetch function
  const environment = (_getMemoEnv = getMemoEnv(withSub)) !== null && _getMemoEnv !== void 0 ? _getMemoEnv : createEnvironment(initialRecords);

  // If your page has Next.js data fetching methods that use Relay, the initial records
  // will get hydrated here
  if (initialRecords) {
    environment.getStore().publish(new RecordSource(initialRecords));
  }
  // For SSG and SSR always create a new Relay environment
  if (typeof window === 'undefined') return environment;
  // Create the Relay environment once in the client
  setMemoEnv(withSub, environment);
  return environment;
};

/**
 * Gets you the current RelayEnvironment, this may return null if we have yet to set one up.
 *
 * Please note; in SSR this will always return null, please use {@link createEnvironment} instead.
 *
 * @supported CSR
 */
export const getEnvironment = () => getMemoEnv(withSubscription);